import React from 'react';

export const RevisionNotesBanner: React.FC<{ notes?: string | null }> = ({ notes }) => {
  if (!notes?.trim()) return null;
  return (
    <div
      className="rounded-lg border-2 border-amber-300 bg-amber-50 px-4 py-3 space-y-1"
      role="alert"
    >
      <p className="text-sm font-semibold text-amber-900">Your team asked for a revision</p>
      <p className="text-sm text-amber-950 whitespace-pre-wrap">{notes.trim()}</p>
      <p className="text-xs text-amber-800 mt-1">
        Update your report below, then submit again when you&apos;re ready.
      </p>
    </div>
  );
};
